import { createSlice } from "@reduxjs/toolkit";
import { getFontCss, getFonts } from "./thunk";

export const initialState = {
  fontNotFound: false,
  fonts: [],
  fontCss: '',
  isFontLoading: false,
  fontUploaded: false,
  selectedFonts: [],
}

const fontSlice = createSlice({
  name: 'Font',
  initialState,
  reducers: {
    setFontNotFound(state, action) {
      state.fontNotFound = action.payload;
    },
    setFonts(state, action) {
      state.fonts = action.payload;
    },
    filterFonts(state, action) {
      state.fonts = action.payload.fonts.filter((item, index) => index !== action.payload.index).map((font) => ({ ...font }));
    },
    setFontCss(state, action) {
      state.fontCss = action.payload;
    },
    setIsFontLoading(state, action) {
      state.isFontLoading = action.payload;
    },
    setFontUploaded(state, action) {
      state.fontUploaded = action.payload;
    },
    setSelectedFonts(state, action) {
      state.selectedFonts = action.payload;
    },
    resetFontState(state) {
      state.fontNotFound = false;
      state.fonts = [];
      state.fontCss = '';
      state.isFontLoading = false;
      state.fontUploaded = false;
      state.selectedFonts = [];
    }
  },
  extraReducers: builder => {
    builder.addCase(getFonts.fulfilled, (state, action) => {
      state.fonts = action.payload;
    });
    builder.addCase(getFontCss.fulfilled, (state, action) => {
      state.fontCss = action.payload;
    });
  }
});

export const {
  setFontNotFound,
  setFonts,
  filterFonts,
  setFontCss,
  setIsFontLoading,
  setFontUploaded,
  setSelectedFonts,
  resetFontState
} = fontSlice.actions;

export default fontSlice.reducer;